import React from "react";
import dataBasesWorks from "../../assets/images/B2B-Data/dataBasesWorks.png";

const DatabaseIntro = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-white tw-border-b tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Layout Grid */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          
          {/* Left Column: Text Content */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              A Database That Works as Hard as You Do
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              Finding the right connections shouldn’t feel like searching for a needle in a haystack. Our B2B database turns prospecting into a breeze, giving you more time to focus on building relationships and closing deals.
            </p>

            <ul className="tw-space-y-6 tw-p-0 tw-m-0">
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Meet Your Next Big Client
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Your dream prospects are just a search away—let us introduce you.
                  </p>
                </div>
              </li>

              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Data That’s Smarter Than a Sales Intern
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Get the accuracy and insights you need to make every pitch perfect.
                  </p>
                </div>
              </li>

              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Stop Prospecting. Start Connecting
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    With our data, you’re always one step ahead.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Right Column: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-35 tw-blur-2xl" />
              <img
                src={dataBasesWorks}
                alt="A Database That Works as Hard as You Do"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default DatabaseIntro;
